import { TokenLogout } from "API/Logout/logout"
import axios from "axios"
const url = process.env.REACT_APP_BANKVERIFY_URL


export const PostPurchaseOrder = async (data, setIsLoading, handleAertOpen) => {
    try {
        await axios.post(`${url}procurement/purchase/purchase_orders/add`, data, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`
            }
        })

            .then((res) => {
                setIsLoading(false)
                handleAertOpen(res.data.message ? res.data.message : "PO created successfully")
                setTimeout(() => {
                    window.location.reload()
                }, 1500)
            })
    }
    catch (error) {
        setIsLoading(false)
        handleAertOpen(error.response && error.response.data.error ? error.response.data.error : "Something went wrong", "error")
    }
}

export const GetPurchaseOrder = async (Filter, setIsLoading, handleAlertOpen, setData, status, page,UserRole) => {

    
    try {
        setIsLoading(true)
        await axios.get(`${url}/procurement/purchase/purchase_orders`, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`
            },
            params: {
                status: status ? status.toLowerCase() : "",
                page: page ? page : 1,
                from_date: Filter.from_date.split('-').reverse().join('-'),
                to_date: Filter.to_date.split('-').reverse().join('-'),
                device: Filter.device,
                ...UserRole
            }
        })
            .then((res) => {
                setIsLoading(false)
                setData(res.data)
            })
    }
    catch (error) {
        setIsLoading(false)
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Something went wrong", "error")
    }
}

export const PostPoStatusChange = async (setIsLoading, data, handleAlertOpen) => {
    try {
        await axios.post(`${url}procurement/purchase/purchase_orders/update`, data, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`
            }
        })
            .then((res) => {
                setIsLoading(false)
                handleAlertOpen(res.data.message ? res.data.message : "Status changed successfully")
                setTimeout(() => {
                    window.location.reload()
                }, 1500)
            })
    }
    catch (error) {
        setIsLoading(false)
        TokenLogout(error)
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Something went wrong", "error")
    }
}